module.exports = "<div id=\"livePhoto\"\n  data-live-photo\n  data-photo-src=\"_photoSrc()\"\n  data-video-src=\"_videoSrc()\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/livePhoto/livePhoto.component.html
// module id = ./src/app/components/livePhoto/livePhoto.component.html
// module chunks = main